import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui";
import { cn } from "@/lib/utils";
import { Student } from "@/types/Student";
import React from "react";

type AvatarShape = "circle" | "square";

type NameAndAvatarProps = Pick<
  Partial<Student>,
  "firstName" | "lastName" | "imageUrl" | "name"
> & {
  alt?: string;
  avatarShape?: AvatarShape;
  avatarSize?: string;
  maxLines?: number;
  nameClass?: string;
  avatarClass?: string;
};

export const NameAndAvatar = ({
  name,
  firstName = "",
  lastName = "",
  imageUrl,
  alt,
  avatarShape = "circle",
  avatarSize,
  maxLines,
  nameClass,
  avatarClass,
}: NameAndAvatarProps) => {
  const displayName = name || `${firstName} ${lastName}`.trim();

  return (
    <div className="flex items-center gap-2">
      <Avatar
        title={alt ?? displayName}
        shape={avatarShape}
        size={avatarSize}
        className={cn("flex-shrink-0", avatarClass)}
      >
        <AvatarImage src={imageUrl?.url} alt={alt ?? displayName} />
        <AvatarFallback>
          <div className="h-10 w-10 animate-pulse rounded-md bg-skeleton" />
        </AvatarFallback>
      </Avatar>
      {displayName && (
        <div className="flex min-w-0 flex-1 flex-col">
          <p
            className={cn(
              `text-sm font-medium ${maxLines ? `line-clamp-${maxLines}` : ""}`,
              nameClass,
            )}
            style={
              maxLines
                ? {
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                  }
                : {}
            }
          >
            {displayName}
          </p>
        </div>
      )}
    </div>
  );
};
